var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosInstance } from '@/api/realApi/_axios';
import { joinUrl } from '@/api/realApi/_utils';
import { getCsrfHeaders } from '@/api/realApi/authApi';
const COMBAT_TRACKER_URL_PATH = '/api/combat_tracker/';
// --- Combat Tracker API ---
export const combatTrackerApi = {
    combat_map: {
        list: (params) => __awaiter(void 0, void 0, void 0, function* () {
            const res = yield axiosInstance.get(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map/']), {
                params,
            });
            return res.data['results'] || res.data;
        }),
        addCharacterToMap: (combatMapId, characterId, initiative) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            const data = { characterId: characterId, initiative: initiative || 0 };
            const res = yield axiosInstance.post(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map/', combatMapId, '/add_character/']), data, config);
            return res.data;
        }),
        removeCharacterFromMap: (combatMapId, characterId) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            const data = { characterId: characterId };
            const res = yield axiosInstance.post(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map/', combatMapId, '/remove_character/']), data, config);
            return res.data;
        }),
        getCombatMapByRoomId: (roomId) => __awaiter(void 0, void 0, void 0, function* () {
            const res = yield axiosInstance.get(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map/', '/get_combat_map_by_room/'], [`room_id=${roomId}`]));
            if (res.data)
                return res.data;
            throw new Error('Combat map not found for room ID: ' + roomId);
        }),
        get: (id) => __awaiter(void 0, void 0, void 0, function* () {
            const res = yield axiosInstance.get(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map/', id]));
            return res.data;
        }),
        create: (data) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            const res = yield axiosInstance.post(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map/']), data, config);
            return res.data;
        }),
        update: (id, data) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            const res = yield axiosInstance.patch(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map/', id]), data, config);
            return res.data;
        }),
        delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            yield axiosInstance.delete(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map/', id]), config);
        }),
    },
    combat_map_character_data: {
        list: () => __awaiter(void 0, void 0, void 0, function* () {
            const res = yield axiosInstance.get(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map_character_data/']));
            return res.data['results'] || res.data;
        }),
        update_character_data: (data) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            const res = yield axiosInstance.patch(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map_character_data/', '/update_character_data']), data, config);
            // await new Promise((resolve) => setTimeout(() => resolve(res.data), 2010));
            return res.data;
        }),
        get: (id) => __awaiter(void 0, void 0, void 0, function* () {
            const res = yield axiosInstance.get(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map_character_data/', id]));
            return res.data;
        }),
        create: (data) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            const res = yield axiosInstance.post(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map_character_data/']), data, config);
            return res.data;
        }),
        update: (id, data) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            const res = yield axiosInstance.patch(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map_character_data/', id]), data, config);
            return res.data;
        }),
        delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            yield axiosInstance.delete(joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map_character_data/', id]), config);
        }),
    },
    combat_map_logs: {
        list: (params) => __awaiter(void 0, void 0, void 0, function* () {
            const url = joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map_log/']);
            const response = yield axiosInstance.get(url, { params });
            return response.data;
        }),
        create: (data) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            const url = joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map_log/']);
            const response = yield axiosInstance.post(url, data, config);
            return response.data;
        }),
        clear: (combatMapId) => __awaiter(void 0, void 0, void 0, function* () {
            const config = yield getCsrfHeaders();
            const url = joinUrl([COMBAT_TRACKER_URL_PATH, '/combat_map_log/clear_logs/']);
            const response = yield axiosInstance.delete(url, Object.assign({ params: { combat_map_id: combatMapId } }, config));
            return response.data;
        }),
    },
};
